export default __webpack_public_path__ + "static/media/36.f625cc96.gif";